
<template> 
 <q-page class="row q-pa-lg" >
        <div class="col-xs-12 col-md-9" style="margin-top: 0; margin-right: auto; margin-bottom: 0; margin-left: auto; ">
        <!-- for normal/tablet web view -->
         <div class="col  gt-xs" style="padding-bottom: 50px">
          <q-stepper active-color="primary"
                        inactive-color="grey"
                        ref="stepper" v-model="StoreStateAD.RedemptionStep" color="primary" animated alternative-labels contractable class="no-shadow" style="border-radius: 1rem !important; background: transparent !important;">
            <q-step icon="settings" class="QStepHead" :done="StoreStateAD.RedemptionStep > 1" :header-nav="StoreStateAD.RedemptionStep > 1" name="1" prefix="1" :title='$t("stepper.title4")'>
                <!-- <q-form class="q-gutter-sm"> -->
                <q-form>
                    <TransactionRedemption></TransactionRedemption>
                </q-form>
            </q-step>
            <q-step icon="message" class="QStepHead" :done="StoreStateAD.RedemptionStep > 2" :header-nav="StoreStateAD.RedemptionStep > 2" name="2" prefix="2" :title='$t("stepper.title5")'>
                <!-- <q-form class="q-gutter-sm"> -->
                <q-form class="" style="padding: 24px !important;">
                    <TAC></TAC>
                </q-form>
            </q-step>
            <q-step icon="assignment_turned_in" class="QStepHead" :done="StoreStateAD.RedemptionStep > 3" :header-nav="StoreStateAD.RedemptionStep >3" name="3" prefix="3" :title='$t("stepper.title11")'>
                <!-- <q-form class="q-gutter-sm"> -->
                <q-form class="q-pa-sm">
                    <ACK/>
                </q-form>
            </q-step>
        </q-stepper>
        </div>
        <!-- for normal/tablet web view -->

 
        <!-- for phone web view -->
        <div class="col lt-sm" style="padding-bottom: 50px">
            <q-stepper vertical active-color="primary" style="border-radius: 1rem !important;"
                        inactive-color="grey" ref="stepper" v-model="StoreStateAD.RedemptionStep"  color="primary" animated alternative-labels contractable class="no-shadow no-border-radius">
            <q-step  icon="settings" class="QStepHead" :done="StoreStateAD.RedemptionStep > 1" :header-nav="StoreStateAD.RedemptionStep > 1" name="1" prefix="1" :title='$t("stepper.title4")'>
                <!-- <q-form class="q-gutter-sm"> -->
                <q-form>
                    <TransactionRedemption></TransactionRedemption>
                </q-form>
            </q-step>
            <q-step icon="message" class="QStepHead" :done="StoreStateAD.RedemptionStep > 2" :header-nav="StoreStateAD.RedemptionStep > 2" name="2" prefix="2" :title='$t("stepper.title5")'>
                <!-- <q-form class="q-gutter-sm"> -->
                <q-form class="" style="padding: 24px !important;">
                    <TAC></TAC>
                </q-form>
            </q-step>
            <q-step icon="assignment_turned_in" class="QStepHead" :done="StoreStateAD.RedemptionStep > 3" :header-nav="StoreStateAD.RedemptionStep >3" name="3" prefix="3" :title='$t("stepper.title11")'>
                <!-- <q-form class="q-gutter-sm"> -->
                <q-form class="q-pa-sm">
                    <ACK/>
                </q-form>
            </q-step>
        </q-stepper>
        </div>
        <!-- for phone web view -->
        
         <q-dialog v-model="userAlert"  persistent transition-show="scale" transition-hide="scale">
                <q-card style="width:700px;max-width:80vw">
                <q-card-section>
                     Hi There!
                </q-card-section>
                  <q-card-section>
                      <div class="row">
                          <div class="col">
                              Please key in your mobile number for TAC purpose
                          </div>
                          <div class="col">
                              <q-input
                                    filled
                                    v-model="StoreStateAO.ContactInformation.MobileNo"
                                    label="Phone"
                                    mask="##########"
                                    hint="Mask: ##########"
                                />
                          </div>
                      </div>
                </q-card-section>
                <q-card-section>
                     <Navigation
                        class="q-px-sm"
                        :ShowConfirmButton=true
                        ConfirmButtonColor="primary"
                        @ConfirmButton="Confirmed()"
                    />
                </q-card-section>
                </q-card>
           </q-dialog>
        </div>
        <q-dialog v-model="requestUpdateAlert"  persistent transition-show="scale" transition-hide="scale">
            <q-card class="my-card" style="max-width:30vw">
            <q-card-section  class="bg-warning text-white text-body1">
                    Hi {{StoreStateAO.PersonalInformation.FullName}},
            </q-card-section>
                <q-form   class="q-gutter-md" @submit="onSubmit">
                    <q-card-section>
                        <UpdateRequest/>  
                    </q-card-section>
    
            <q-card-actions align="right" >
                <q-btn label="Update" color="primary" text-color="white" type="submit" />
            </q-card-actions>
            </q-form>
            </q-card>
        </q-dialog>
    </q-page>
</template>

<style>

.QStepHead{
    cursor: default;
}
.q-stepper__header--alternative-labels .q-stepper__tab {
    min-height: 90px !important;
}

.q-stepper--horizontal .q-stepper__step-inner {
    padding: 0px !important;
}
.q-stepper__step-inner {
    padding: 0px !important;
}

.q-stepper__nav button {
    background: #ff6666 !important;
}

.q-stepper__header.row.items-stretch.justify-between.q-stepper__header--alternative-labels.q-stepper__header--border {
    margin-bottom: 1rem;
    background: white;
    border-radius: 1rem !important;
}
.q-stepper__content.q-panel-parent {
    background: white;
    border-radius: 1rem !important;
}

</style>
<script >
    import {
        mapActions
    } from 'vuex';
import ACK from '@/components/Acknowledgement.vue'
import TAC from '@/components/TAC.vue'
import Declaration from '@/components/Declaration.vue'
import Navigation from '@/components/NavigationButtons'
import AC from '@/components/ApplicantCredentials.vue'
import AD from '@/components/ApplicantDetails.vue'
import FATCA from '@/components/FATCA.vue'
import ED from "@/components/EmploymentDetails.vue";
import Summary from "@/views/SummaryAccountOpening.vue"
import TransactionRedemption from '@/views/ClientTransaction.vue'
import UpdateRequest from '@/components/UpdateRequest.vue'
import store from '../store';
/* window.onbeforeunload = function() {
    return "You're leaving the site.";
};
 */
import {
    Notify

} from 'quasar'
export default {
    name: 'LandingPage',
    components: {
        Navigation,
        Declaration,
        AC,
        AD,
        ED,
        FATCA,
        TAC,
        ACK,
        Summary,
        TransactionRedemption,
        UpdateRequest
    },
    data() {
        return {
            //fatca

            StoreStateCD: store.state.CD,
            StoreStateLookup: store.state.Lookup,
            StoreStateAD: store.state.AD,
            StoreStateFATCA: store.state.FATCA,
            StoreStateED: store.state.ED,
            StoreStateAO: store.state.AOD,
            StoreStateT: store.state.Transactions,
            StoreStateLogin: store.state.Login,
            userAlert:false,
            SelectAgent: false,
            requestUpdateAlert:false,            
            isIEBrowser: false,
        }
    },created() {
       store.commit('ResetToken')
        store.commit('ResetTransactionDetails')
        store.dispatch("ClearClientDetails")
        store.commit("ResetAODetails");
        store.commit("ResetState_ClientDetails");
        store.commit("ResetTransactionDetails");
        store.commit("ResetState_AD");

    
        var ua = window.navigator.userAgent; 
        var msie = ua.indexOf('MSIE '); 
        if (msie > 0) { 
          this.isIEBrowser = true;
            // IE 10 or older, return version number 
          this.BrowserType  = 'IE ' + parseInt(ua.substring( msie + 5, ua.indexOf('.', msie)), 10)
        } 
        var trident = ua.indexOf('Trident/'); 
        if (trident > 0) { 
            // IE 11, return version number 
          this.isIEBrowser = true;
          var rv = ua.indexOf('rv:'); 
          this.BrowserType ='IE ' + parseInt(ua.substring(   rv + 3, ua.indexOf('.', rv)), 10)
            
        } 
        var edge = ua.indexOf('Edge/'); 
        if (edge > 0) { 
          
            //Edge (IE 12+), return version number 
           this.isIEBrowser = true;
           this.BrowserType = 'IE ' + parseInt(ua.substring(   edge + 5, ua.indexOf('.', edge)), 10)
        }

      if(this.isIEBrowser === true){
         this.$q.dialog({
              title: 'Alert',
              message: "Hi, Our application is not supported in : "+this.BrowserType+". Best use in Google Chrome or Mozilla Firefox. You may continue by Copy and Paste the URL: https://investdev.affinhwangam.com" +
              this.StoreStateLogin.RouteToPath+" in Google Chrome or Mozilla Firefox"
          }).onOk(() => {
              this.triggerLogout();
          })   
     }
  },
    async mounted() {
        store.commit('ResetToken')
        store.dispatch("ClearClientDetails")
        store.commit("ResetState_ClientDetails");
        store.commit("ResetTransactionDetails");
        store.commit("ResetState_AD");

        let tempid = localStorage.getItem('Creation_uuid');
        this.StoreStateAD.Creation_uuid = tempid
        localStorage.clear();

        this.StoreStateAD.RedemptionStep = "1"
        this.StoreStateAD.TAC_code =""
        this.StoreStateT.inComingTransaction = 'Redemption'

        var url = new URL(window.location.href);
        var url_string = url.search;
        var appID = url.searchParams.get('appId');

        if(appID!=null){

          this.StoreStateLogin.incomingAppID = appID
        }

        if (this.StoreStateLogin.incomingAppID != undefined) {
            //move the whole function into this//
            this.$q.loading.show({
                    spinnerSize: 50
                }),

                this.GetEmisSwitchRedeemApplication({
                    ApplicationId: this.StoreStateLogin.incomingAppID

                })
                .then(res => {
                    if (res == true) {
                        var userID = "";
                        if (this.StoreStateAO.PersonalInformation.IdType === 'NewIC') {
                            userID = this.StoreStateAO.PersonalInformation.NRIC
                        } else {
                            userID = this.StoreStateAO.PersonalInformation.OldID
                        }
                        this.$store.dispatch('Logging',{
                           
                            appid : '2',
                             typeid :'4', 
                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'GetEmisSwitchRedeemApplication(Redeem), ID Type -> ' + this.StoreStateAO.PersonalInformation.IdType + '. userID - > '+ userID
                        });

                        this.GetCif({
                            ApplicationId: userID
                        }).then(res => {
                            this.$store.dispatch('Logging',{
                            
                                appid : '2',
                                typeid :'4', 
                                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' GetCif (Redeem)  res - > '+  res
                            });

                            if (res == true) {
                                 this.TrnxCifCustomerInfo({
                                ApplicationId: userID
                            }).then(res=>{
                                this.$store.dispatch('Logging',{
                                    appid : '2',
                                    typeid :'4', 
                                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'TrnxCifCustomerInfo (Redeem), res : ' + res
                                });
                                if(res === true){
                                    this.GetAccountHoldings()
                                    .then(res => {
                                        this.$store.dispatch('Logging',{
                                            appid : '2',
                                            typeid :'4', 
                                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' GetAccountHoldings (Redeem), ID Type -> ' + this.StoreStateAO.PersonalInformation.IdType + '. res - > '+  res
                                        });
                                        if (res == true) {
                                            if((this.StoreStateAO.ContactInformation.MobileNo == '') || (this.StoreStateAO.ContactInformation.EmailAddress == '')){
                                                this.requestUpdateAlert = true;
                                                this.$q.loading.hide()
                                            }else{ 
                                                this.$q.loading.hide()
                                            }
                                        
                                        }else if(res === -1){
                                            this.$store.dispatch('Logging',{
                                                appid : '2',
                                                typeid :'4', 
                                                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'GetAccountHoldings (Redeem), error ' //+ res
                                            });

                                            this.$q.dialog({
                                                title: 'Error',
                                                message : 'Investor Holding details API is not responding'
                                            })
                                                this.$q.loading.hide()
                                        }else{
                                            this.$store.dispatch('Logging',{
                                                appid : '2',
                                                typeid :'4', 
                                                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'GetAccountHoldings (Redeem), error ' //+ res
                                            });
                                            this.$q.dialog({
                                                title: 'Error',
                                                message : res
                                            })
                                            this.$q.loading.hide()
                                        }
                                    })
                                }else{
                                    this.$q.dialog({
                                        title: 'Error',
                                        message: 'Unable to retrieve CIF Info',
                                        persistent: true
                                    }).onOk(() => {
                                    // console.log('OK')
                                        this.triggerLogout();
                                    })

                                }
                            })
                                
                                       /*  this.GetLastServicingAgent()
                                        .then(res=>{

                                            this.$store.dispatch('Logging',{
                                                appid : '2',
                                                typeid :'4', 
                                                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' GetLastServicingAgent (Redeem), ID Type -> ' + this.StoreStateAO.PersonalInformation.IdType + '. res - > '+  res
                                            });

                                            if(res === true){ */
                                                
                                          /*   }else{
                                               
                                                this.$store.dispatch('Logging',{
                                                    appid : '2',
                                                    typeid :'4', 
                                                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'GetAccountHoldings (Redeem), error ' //+ res
                                                });
                                                this.$q.dialog({
                                                    title: 'Error',
                                                    message : res
                                                })
                                                this.$q.loading.hide() 
                                            }
                                        }) */
                               
                                      
                            }else {
                                   this.$store.dispatch('Logging',{
                                    appid : '2',
                                    typeid :'4', 
                                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'GetCif (Redeem), error  -> ' + res
                                });

                                this.$q.dialog({
                                    title: 'Message',
                                    message: res,
                                    persistent: true
                                }).onOk(() => {
                                // console.log('OK')
                                    this.triggerLogout();
                                })
                                this.$q.loading.hide()
                            }
                        })
                    } else if(res == false){
                         this.$store.dispatch('Logging',{
                            appid : '2',
                            typeid :'4', 
                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'GetEmisSwitchRedeemApplication (Redeem), EMIS GET TRX FAILE '
                        });

                       this.$q.loading.hide()
                        this.$router.push({ name: 'Maintenance'});
                        /* this.$q.dialog({
                            title: 'Message',
                            message : this.$t("common.restartTrnx")
                        }) */
                    }else{
                        
                        this.$q.loading.hide()
                          this.$store.dispatch('Logging',{
                            appid : '2',
                            typeid :'4', 
                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'GetEmisSwitchRedeemApplication (Redeem), Warning  -> ' + res
                        });
                        //this.$router.push({ name: 'Maintenance'});

                         this.$q.dialog({
                             title : 'Warning',
                            message : res,
                            persistent : true
                        }).onOk(() => {
                            // console.log('OK')
                            this.triggerLogout();
                        }) 
                    }
                })
            // })
            
        }else{
            this.$router.push({ name: 'Maintenance'});
        }
        
        //this.userAlert = true
    },
    methods: {
        ...mapActions([
            "GetEmisSwitchRedeemApplication",
            "GetLookup",
           // "GeteMisLookup",
            "TrnxCifCustomerInfo",
            "CIFInfo",
            "GetCif",
            "GetAccountHoldings",
            "GetListOfFundForOnboarding",
            "triggerLogout",
            "CIFAccountInformationUpdate",
            "GetLastServicingAgent",
        ]),

        Confirmed:function(){
            
        this.userAlert = false
        },
        onSubmit(){
            this.$q.loading.show({
                spinnerSize: 50
            }), 
            this.CIFAccountInformationUpdate()
            .then(res => {

                this.$store.dispatch('Logging',{
                    appid : '2',
                    typeid :'4', 
                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' CIFAccountInformationUpdate (Redeem),  res - > '+  res
                });
                
                if(res == true){

                    this.requestUpdateAlert = false;
                      location.reload()
                    this.$q.loading.hide()
                }else{
                this.$q.dialog({
                    title: 'Error',
                    message: 'Sorry, unable to update your info. Please contact our Customer Support to assist you on this'
                })
                this.$q.loading.hide()
                }

            })
        }
    }
}
</script>


<style>

</style>

<style>

@media print {
    .Acknowlegdement{
        display : block;
    }
    .q-stepper__header,.logoutbutton{
        display : none;
    }
    .AckBtn{
        display : none;
    }
}

.q-stepper--horizontal .q-stepper__step-inner {
    padding: 0px !important;
}
</style>